import { BackofficeAdhesionRequestsInterface } from '../../../../interfaces/dto/backoffice-adhesion-requests/backoffice-adhesion-requests';

export class BackofficeAdhesionRequestsModel implements BackofficeAdhesionRequestsInterface {
  active: boolean = false;
  address: string = '';
  asfNumber: string = '';
  company: string = '';
  creationDate: string = '';
  email: string = '';
  fiscalNumber: string = '';
  id: number = -1;
  location: string = '';
  name: string = '';
  partnershipId: number = -1;
  phone: string = '';
  postalCode: string = '';
  requestStatus: string = '';

  constructor(init?: Partial<BackofficeAdhesionRequestsModel>) {
    Object.assign(this, init);
  }
}
